export enum ENVIRONMENT {
	DEVELOPMENT = 'development',
	PRODUCTION = 'production',
	STAGE = 'staging',
}

const viteEnv: Record<string, any> = (import.meta as ImportMeta & { env?: Record<string, any> }).env ?? {};

export const isDev = (): boolean => Boolean(viteEnv.DEV);
export const isProd = (): boolean => Boolean(viteEnv.PROD);

export const isAppStage = (): boolean => viteEnv.PUBLIC_ENV__APP_ENV === ENVIRONMENT.STAGE;

export const isAppProd = (): boolean => viteEnv.PUBLIC_ENV__APP_ENV === ENVIRONMENT.PRODUCTION;

export const getAppEnv = (): string => viteEnv.PUBLIC_ENV__APP_ENV ?? ENVIRONMENT.DEVELOPMENT;

export const getAppVersion = (): string => viteEnv.PUBLIC_ENV__APP_VERSION ?? 'N/A';

export const isServer = (): boolean => typeof window === 'undefined';
export const isClient = (): boolean => typeof window !== 'undefined';

export const DEALER_WEBAPP_URL_STAGE = 'https://stage-pro.motorway.co.uk';
export const DEALER_WEBAPP_URL_PROD = 'https://pro.motorway.co.uk';
